app.controller('SimilarSearchController',
	["$scope", "$timeout", "ApartmentSearchModel", "ApartmentSearchService", function($scope, $timeout, ApartmentSearchModel, ApartmentSearchService) {

		$scope.SearchModel = ApartmentSearchModel;
		$scope.resultIdentifier = "similarSearch";
		$scope.searchResults = ApartmentSearchModel.results[$scope.resultIdentifier];

		$scope.WatchResultSet = function(resultSetName) {
			ApartmentSearchService.AddQueryListener(resultSetName, function() {

				// Tee haku similar-ehdoilla tässä, eli muuten samat ehdot paitsi hinta -10/+10 %
				// Eli tehdään kaksi hakua, molemmilta puolilta hintahaitaria.
				var q1 = ApartmentSearchService.CreateQuery();
				q1.CloneSettingsFromAnotherQuery(ApartmentSearchModel.query);
				q1.SetResultLimit(4);
				q1.SetSimilar(true);

				$scope.searchResults = ApartmentSearchModel.results[$scope.resultIdentifier];

				ApartmentSearchService.RunQuery(q1, $scope.resultIdentifier, false, function() {
					if($scope.packeryControls !== undefined) {
						$scope.packeryControls.ResetAndReLayout();
					}
				});
			});
		};

		$scope.SetResultSetId = function(searchID) {
			if(ApartmentSearchModel.results[searchID] === undefined) {
				ApartmentSearchModel.results[searchID] = {};
			}
			$scope.resultIdentifier = searchID;
			$scope.searchResults = ApartmentSearchModel.results[searchID];
		};

		$scope.PackeryInit = function(packery, controls) {
			$scope.packery = packery;
			$scope.packeryControls = controls;
			controls.ResetAndReLayout();
		};

		$scope.$watch('searchResults.loading', function(newVal) {
			if(!newVal && $scope.packery) {
				$timeout(function() {
					if($scope.packeryControls !== undefined) {
						$scope.packeryControls.ResetAndReLayout();
					}
				});
			}
		});

		$scope.HasSearchResults = function() {
			return ($scope.searchResults && $scope.searchResults.data && $scope.searchResults.data.results.length > 0);
		};
	}]
);